module.exports = __webpack_public_path__ + "img/claims-1.e24d4962.svg";